// @flow

import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';

import ScribeConversation from './ScribeConversation';
import {
  acceptScribeConversationRequest,
  clearScribeConversationState,
  clearScribeSessionState,
  createNewConversation,
  exitScribeMode,
  getTranscriptText,
  getTranscriptStats,
  reconnectToWebSocket,
  resetConversation,
  scribeCreateTranscript,
  scribeDeselectTranscriptWord,
  startRecord,
  stopRecord,
  switchPlatform,
  switchWebProduct,
  toggleSideBar,
  updateBroadcastToZoomToken,
  updateConversationEndedStatus,
  updateFullScreen,
  updateElectronCaptionMode,
  updateIsInConversation,
  updateNewTranscriptInputVisibility,
} from '../../actions';

const mapStateToProps = ({
  scribeTranscriptUI: {
    fontSize,
    fullScreen,
    electronCaptionMode,
    insertSpeakerNameMode,
    updateAudioSourceMode,
  },
  scribeSession: {
    activeFeatures,
    backendSupport,
    branch,
    captioner,
    currentPlatform,
    displayable,
    inConferenceCall,
    intercomDisplayed,
    lightView,
    loading,
    mirror,
    socketConnected,
    subscription
  },
  scribeConversation: {
    broadcastToZoomToken,
    conversationEnded,
    conversationEndedMessage,
    conversationEndedSuccessfully,
    conversationOrigin,
    conversationRequested,
    conversationStarted,
    inTwilioCalls,
    isInConversation,
    lastMutationReceived,
    muted,
    recording,
    scribe,
    status,
    token,
    transcriptsCurrent,
    transcriptsFinal,
    ui: { newTranscriptInputVisibility },
  },
}) => ({
  activeFeatures,
  backendSupport,
  branch,
  broadcastToZoomToken,
  conversationEnded,
  conversationEndedMessage,
  conversationEndedSuccessfully,
  conversationOrigin,
  conversationRequested,
  conversationStarted,
  currentPlatform,
  displayable,
  electronCaptionMode,
  fontSize,
  fullScreen,
  haveTranscripts: transcriptsCurrent.length + transcriptsFinal.length > 0,
  inConferenceCall,
  insertSpeakerNameMode,
  intercomDisplayed,
  inTwilioCalls,
  isInConversation,
  lastMutationReceived,
  lightView,
  loading,
  mirror,
  muted,
  newTranscriptInputVisibility,
  recording,
  scribe,
  socketConnected,
  status,
  subscription,
  token,
  updateAudioSourceMode,
  user: captioner,
});

export default withSnackbar(
  connect(
    mapStateToProps,
    {
      acceptScribeConversationRequest,
      clearScribeConversationState,
      clearScribeSessionState,
      createNewConversation,
      exitScribeMode,
      getTranscriptText,
      getTranscriptStats,
      reconnectToWebSocket,
      resetConversation,
      scribeCreateTranscript,
      scribeDeselectTranscriptWord,
      startRecord,
      stopRecord,
      switchPlatform,
      switchWebProduct,
      toggleSideBar,
      updateBroadcastToZoomToken,
      updateConversationEndedStatus,
      updateFullScreen,
      updateElectronCaptionMode,
      updateIsInConversation,
      updateNewTranscriptInputVisibility,
    }
  )(ScribeConversation)
);
